<div class="building-scan-detail-page">
  <wr-full-screen-panel [buttons]="false">
    <nb-card [nbSpinner]="loading()">
      <nb-card-header>
        <button nbButton ghost status="primary" (click)="navigateBack()">
          <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
        </button>

        <div class="title">
          <ng-container>
            <h5>{{ buildingScan()?.name }}</h5>
          </ng-container>
        </div>
        <button nbButton class="delete-button" ghost status="primary" (click)="deleteScan()">
          <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
        </button>
        <button nbButton ghost (click)="createShareLink()">
          <nb-icon pack="eva" icon="share-outline"></nb-icon>
        </button>
        <wr-full-screen-button></wr-full-screen-button>
      </nb-card-header>
      <nb-card-body class="iframe-container">
        <div class="iframe-wrapper">
          @if(buildingScanLink() !== null) {
            <iframe [src]="buildingScanLink()"
                    scrolling="no"
                    frameborder="0"
                    allowfullscreen>
            </iframe>
          }
        </div>
      </nb-card-body>
    </nb-card>
  </wr-full-screen-panel>
</div>
